export default /* html */ `
<ui-page>
  <ui-page-body>
    <page-header>
      <ui-heading type="h1" slot="title">ScaffoldJS</ui-heading>

      <ui-heading type="h2" slot="intro">A mediocre framework at best.</ui-heading>
    </page-header>
    <ui-page-content>
      <div class="usp">
        ❌ Blazlingly fast
      </div>
      <div class="usp">
        ❌ Highly optimized
      </div>
      <div class="usp">
        ❌ Super small bundle size
      </div>

      <div class="usp">
        Does it work? Kinda <span class="smiley">🕺🏻</span>
      </div>
    </ui-page-content>
  </ui-page-body>
</ui-page>
`
